import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { SHOPIFY_MODE } from 'views/v2/shopify-home/constants';
import { getQuoteToRender, getQuotesToRender } from 'helper/order';
import { isValidQuote } from 'helper/quote';
import calcPrice from 'common/utils/calc-price';

export const getMsdCtaData = ({ mode, multipleOrders }) => {
  const err = true;
  if (mode !== SHOPIFY_MODE.SHOPIFY_BOOK_MULTIPLE) return { err };
  const msdInfo = _get(multipleOrders, '[0].msdInfo');
  if (!msdInfo) return { err };

  // calculate total from single bookings
  const quotes = getQuotesToRender(multipleOrders);
  const validQuotes = [];
  let totalQuoteAmount = 0;
  const totalAmount = quotes.reduce((acc, quote) => {
    if (!isValidQuote(quote)) return acc;

    validQuotes.push(quote);
    const currentQuoteAmount = _get(quote, 'amount');
    totalQuoteAmount += currentQuoteAmount;
    const currentCurrency = _get(quote, 'currency');
    const currentFormattedAmount = calcPrice(
      currentQuoteAmount,
      currentCurrency,
    );
    return acc + currentFormattedAmount;
  }, 0);

  if (_isEmpty(validQuotes)) return { err };

  // get best price from msd
  const msdQuote = _get(msdInfo, 'cheapestServiceTypeWithQuote.quote');
  const msdQuoteAmount = _get(msdQuote, 'amount');
  const msdCurrency = _get(msdQuote, 'currency');

  const msdFormattedAmount = calcPrice(msdQuoteAmount, msdCurrency);

  if (!msdFormattedAmount) {
    return { err };
  }
  const totalSavings = totalAmount - msdFormattedAmount;
  if (totalSavings <= 0) return { err };

  return {
    err: false,
    validQuotes,
    totalQuoteAmount,
    totalSavings,
    msdInfo,
  };
};

export const getMsdOrderSavingAmount = ({ mode, msdOrder }) => {
  const err = true;
  if (mode !== SHOPIFY_MODE.SHOPIFY_BOOK_MSD) return { err };

  const singleBookingsTotalAmount = _get(msdOrder, 'singleBookingsTotalQuote');
  if (!singleBookingsTotalAmount) return { err };

  const quote = getQuoteToRender(msdOrder);
  if (!isValidQuote(quote)) return { err };
  const { currency, amount } = quote;
  const msdAmount = calcPrice(amount, currency);
  const savingsAmount =
    calcPrice(singleBookingsTotalAmount, currency) - msdAmount;
  if (savingsAmount <= 0) return { err };
  return { savingsAmount, currency, amount };
};

export default getMsdCtaData;
